import { Directive, HostBinding, input } from '@angular/core';

@Directive({
  selector: '[splUiButtonSize]',
})
export class SplUiButtonSize {
  readonly size = input.required<'l'>({ alias: 'splUiButtonSize' });

  @HostBinding('class')
  get buttonSizeClass() {
    return `spl-ui-button-size--${this.size()}`;
  }
}
